const FailedStatusImage = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
            <g filter="url(#filter0_dd_8973_28990)">
                <path
                    d="M24.9727 13.7895C26.3607 13.8947 27.5456 14.4912 28.5273 15.5789C29.5091 16.6316 30 17.8947 30 19.3684C30 20.9123 29.4583 22.2456 28.375 23.3684C27.3255 24.4561 26.056 25 24.5664 25H10.5C8.70573 25 7.16536 24.3509 5.87891 23.0526C4.6263 21.7193 4 20.1228 4 18.2632C4 16.614 4.55859 15.1404 5.67578 13.8421C6.82682 12.5088 8.19792 11.7544 9.78906 11.5789C10.5 10.2105 11.4987 9.10526 12.7852 8.26316C14.0716 7.42105 15.4766 7 17 7C18.8281 7 20.5208 7.66667 22.0781 9C23.6693 10.3333 24.6341 11.9298 24.9727 13.7895Z"
                    fill="#D32F2F"
                />
                <path
                    d="M16 21.3802C16 20.7812 16.4419 20.2865 17 20.2865C17.5581 20.2865 18 20.7812 18 21.3802C18 22.0052 17.5581 22.5 17 22.5C16.4419 22.5 16 22.0052 16 21.3802ZM16 11H18V19.1667H16V11Z"
                    fill="white"
                />
            </g>
            <defs>
                <filter id="filter0_dd_8973_28990" x="-3" y="-4" width="40" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8973_28990" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow_8973_28990" result="effect2_dropShadow_8973_28990" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8973_28990" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};

export default FailedStatusImage;
